import { useState, type FormEvent } from 'react';
import {
  useToolCall, PlatformSelect, GenerateButton, CopyButton, LimitReached, ResultFunnel, ErrorNote,
  type ToolPlatform,
} from './aiToolShared';

export function BioGenerator() {
  const [description, setDescription] = useState('');
  const [platform, setPlatform] = useState<ToolPlatform>('instagram');
  const { run, loading, error, limitReached, data } = useToolCall<{ bios: string[] }>('/api/tools/bio');

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (description.trim().length < 3) return;
    run({ description: description.trim(), platform });
  }

  return (
    <div>
      <form onSubmit={onSubmit} className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Describe tu cuenta o negocio</span>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            maxLength={600}
            placeholder="Ej.: Soy nutricionista, ayudo a mujeres a comer mejor sin dietas. Tono cercano y motivador."
            className="mt-1 w-full rounded-xl border border-slate-300 p-3.5 text-slate-900 focus:border-brand-500 focus:ring-2 focus:ring-brand-200 outline-none resize-y"
          />
        </label>
        <PlatformSelect value={platform} onChange={setPlatform} />
        <GenerateButton loading={loading} label="Generar bios" />
      </form>

      {error && <ErrorNote message={error} />}
      {limitReached && <div className="mt-6"><LimitReached /></div>}

      {data && data.bios.length > 0 && !limitReached && (
        <ResultFunnel>
          <ul className="space-y-3">
            {data.bios.map((bio, i) => (
              <li key={i} className="flex items-start justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4">
                <p className="text-slate-800 whitespace-pre-wrap leading-relaxed">{bio}</p>
                <CopyButton text={bio} className="shrink-0" />
              </li>
            ))}
          </ul>
        </ResultFunnel>
      )}
    </div>
  );
}
